import getCookie from './getCookie';
import setCookie from './setCookie';

export { getCookie, setCookie };